import styled from 'styled-components'
import unisatcpro from '../../assets/img/unisatcpro_back_real.jpg'
import bg from '../../assets/img/bg.jpg'


export const Container = styled.div`
position:absolute;
z-index:9999;
width:100%;
padding:70px 0;
display:flex;
flex-direction:column;
animation:myFade 1.5s forwards;

@keyframes myFade {
    0% {
        opacity:0%;
    }
    100% {
        opacity:100%;
    }
}
@media(max-width:1024px){
    gap:40px;
}
`;

export const Bg = styled.div<{bg: string}>`
position:fixed;
left:0;
top:0;
width:100%;
height:100%;
z-index:1;
transform:scale(1.1);
background: url(${props => props.bg === 'unisatcpro'? unisatcpro : bg}) repeat #000;
background-size: cover;
background-position: center;
${props => props.bg === 'unisatcpro'? '-webkit-animation: myScale ease-out 1.4s both; animation: myScale ease-out 1.4s both;':null}

@keyframes myScale {
    from {
        transform:scale(1);
    }


@media(max-width:1024px){
    background: url(${props => props.bg === 'unisatcpro'? unisatcpro : bg}) #000;
    background-size:cover;
    background-position: center;
    position:fixed;
}
`;

export const Title = styled.div<{bg: string}>`
    text-align:center;
    color:${props => props.bg === 'unisatcpro'? '#FFF':'#000'};
    z-index:9999;
    
    h1 {
        margin:0;
        font-family:Raleway;
        font-size:60px;
        font-weight:900;
    }
    
    h3 {
        font-weight:300;
        font-size:25px;
        margin:0;
    }
    `;
    
    export const Footer = styled.div<{bg: string}>`
    display:flex;
    align-items:center;
    justify-content:center;
    z-index:9999;
    
    img {
        height:50px;
    }

    span {
        font-size:18px;
        font-weight:300;
        margin-left:30px;
        color:${props => props.bg === 'unisatcpro'? '#FFF':'#000'};
        border-left:1px solid ${props => props.bg === 'unisatcpro'? '#FFFFFF5c':'#585858'};
        padding:5px 0;
        padding-left:30px;
    }
`;